import React,{useState,useEffect} from 'react'
import { ConfigurationPageStyle } from './Configuration.style'
import TopBar from '../../components/TopBar/TopBar'
import Footer from '../../components/footer/Footer'
import { HeadingStyle } from '../../styles/HeadingStyles'
import InputRange from 'react-input-range';
import { useDB } from '../../context/DynamoDBContext'
import { useQueryClient,useQuery } from '@tanstack/react-query'
import { useReload } from '../../context/ReloadContext'
import { toast } from 'react-toastify'
import { getConfigurations } from '../../api/ConfigurationApi'
import { MainBodyStyle } from '../../styles/MainBodyStyles'
import { TextErrorStyle } from '../../styles/ErrorStyles'

const RssiConfiguration = () => {
    const {dynamoDBClient}=useDB()
    const queryClient = useQueryClient()
    const {reload}=useReload()
    const [green, setGreen] = useState({min:0,max:100})
    const [yellow, setYellow] = useState({min:0,max:100})
    const [red, setRed] = useState({min:0,max:100})
    const [enableApi, setEnableApi] = useState(false)
    const [error, setError] = useState("")
    const [btnDisable, setBtnDisable] = useState(false)
    const [rssi, setRssi] = useState({})

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [])


    useEffect(() => {
      if(dynamoDBClient){
        setEnableApi(true)
      }else{
        setEnableApi(false)
      }
    }, [dynamoDBClient])

    useEffect(() => {
      if(reload){
        queryClient.fetchQuery(["getRssiConfigurations"])
      }
    }, [reload])

    const handleError=(type)=>{
        if(type==="getRssiConfigurations"){
            toast.error("Error while loading Configuration",{
                bodyClassName:"notification-div-error",
                progressClassName:"progress-bar-error"
            })
        }
    }

    const {
        data:configData,
        status:configStatus
    }=useQuery({
        queryKey:["getRssiConfigurations"],
        queryFn:()=>getConfigurations(dynamoDBClient,"RSSI"),
        enabled:enableApi,
        onSuccess:(data)=>{
            if(data.length>0){
                const config=data[0]
                setRssi(config)
                let redRange=+config.ConfigurationData.Red
                let greenRange=+config.ConfigurationData.Green
                setYellow({min:redRange+1,max:greenRange-1})
                setRed({min:0,max:redRange})
                setGreen({min:greenRange,max:100})
            }else{

            }
        },
        onError:(error)=>{
            console.log("getRssiConfigurations :",error)
            handleError("getRssiConfigurations")
        }
    })

    const updateRssiConfigurations=async()=>{
        try {
           
            setBtnDisable(true)
            var params={
                TableName:"Configurations",
                Key:{"ConfigurationId":rssi.ConfigurationId,"ModeType":rssi.ModeType},
                UpdateExpression: "SET ConfigurationData = :val ",
                ExpressionAttributeValues:{
                    ":val":{
                        "Green": `${green.min}`,
                        "Red": `${red.max}`
                        
                    }
                },
                ReturnValues: "ALL_NEW", 
            }
            const result= await dynamoDBClient.update(params).promise()
            setBtnDisable(false)
            toast("Updated Successfully")
        } catch (error) {
             setBtnDisable(false)
            setError("Something went wrong. Try Again")
        }
    }

    const handleGreenChange=(value)=>{
        
        if(value.min-2>=yellow.min){
            
            setGreen(value)
            setYellow({...yellow, max: value.min-1})
        }
    }
    

    const handleYellowChange=(value)=>{
        
        if(!(value.max+1 >=100 || value.min-1<=0)){
           setYellow(value)
            setRed({...red, max:value.min-1})
            setGreen({...green, min:value.max+1})
        }
       
    }

    const handleRedChange=(value)=>{
        

        if(value.max+2<=yellow.max){
            setRed(value)
            setYellow({...yellow,min:value.max+1})
        }
    }

  return (
    <ConfigurationPageStyle>
        <TopBar authorized={true}  />
        <MainBodyStyle>
            <HeadingStyle>RSSI Configurations</HeadingStyle>
            <div className='configurationCard'>
                <h5>Green Range</h5>
                <div className='green'>
                    <InputRange
                        maxValue={100}
                        minValue={0}
                        value={green}
                        onChange={handleGreenChange}
                        formatLabel={value => `${value}%`}
                        
                    />
                </div>
                <h5>Yellow Range</h5>
                <div className='yellow'>
                    <InputRange
                        maxValue={100}
                        minValue={0}
                        value={yellow}
                        onChange={handleYellowChange}
                        className="input-range--yellow"
                        formatLabel={value => `${value}%`}
                    />
                </div>
                <h5>Red Range</h5>
                <div className='red'>
                    <InputRange
                        maxValue={100}
                        minValue={0}
                        value={red}
                        onChange={handleRedChange}
                        className="input-range--red"
                        formatLabel={value => `${value}%`}
                    />
                </div>
                <button 
                  type="submit" 
                  className={"btn form-button"}
                  disabled={btnDisable}
                  onClick={updateRssiConfigurations}
                >
                    Update
                </button>
                {error!=="" && <TextErrorStyle>{error}</TextErrorStyle>}
            </div>
        </MainBodyStyle>
        
        <Footer style="footer" />
    </ConfigurationPageStyle>
  )
}

export default RssiConfiguration